/**
 * Submits the ipout text filter.
 */
export function inputTextFilter() {
	const $tableHeaderContainer = $( '.m__dashboard-header' );
	const $tableContainer = $( '.m__dashboard-table' );
	const $textInput = $tableHeaderContainer.find( '.input-filter-text' );
	const $form = $tableHeaderContainer.find( '.m__form-input--search-form' );
	const $submitButton = $tableHeaderContainer.find( '.m__form-input--search-submit' );

	/**
	 * The text input search function.
	 *
	 * @param {objec} event the form event.
	 */
	function search( event ) {
		event.preventDefault();
		const filtertext = $textInput.val();
		if ( !filtertext || 0 === filtertext.length ) {
			return;
		}

		const data = {
			filterby: 'claimant',
			filtertext: filtertext,
		};
		$tableContainer.trigger( 'tableUpdate', data );
		$tableHeaderContainer.trigger( 'filtersActive' );
	}

	$submitButton.on( 'click', search );
	$form.submit( search );
}